import {NewStableFormValues} from '../../types/NewStableFormValues';

export const validate = (values: NewStableFormValues) => {
    const errors: { [_ in keyof NewStableFormValues]?: string } = {};
    if (!values.breedingId) { errors.breedingId = 'Číslo chovu je povinná položka.'; }
    if (!values.stableName) { errors.stableName = 'Jméno stáje je povinná položka.'; }
    if (!values.companyName) { errors.companyName = 'Jméno společnosti je povinná položka.'; }
    return errors;
};
